<template>
    <v-dialog
        v-model="dialog"
        persistent
        :width="800"
    >
        <v-card v-if="notification">
            <v-toolbar dark color="primary" flat>
                <v-toolbar-title>{{ notification.title }}</v-toolbar-title>
                <v-spacer></v-spacer>
                verstuurd op: {{notification.created_at | formattedDate}}
            </v-toolbar>

            <v-img :src="notification.image_url" />
            <v-img v-if="image" :src="image" />

            <v-card-text class="mt-2">
                <p class="text-subtitle-1" v-html="notification.message"></p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="close()">
                    Sluiten
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import FileModel from "@/models/File/File";
import Notification from "@/models/User/Notification/Notification";
import User from "@/models/User/User";

export default {
    name: "notificationShow",
    data() {
        return {
            dialog: false,
            image: false,
            notification: null,
        }
    },
    methods: {
        close() {
            this.dialog = false;
            this.notification = null;
        },
        showNotification(notification) {
            if (this.notification) {
                return;
            }
            this.notification = notification;

            Notification.updateReceived(notification.id, User.loggedInUser().id);

            if (notification.file_id) {
                FileModel.api().find(notification.file_id).then(file => {
                    this.image = file.public;
                    this.dialog = true;
                });
            }

            this.dialog = true;
        }
    },
    sockets: {
        'user:notification'(data) {
            this.showNotification(data.notification);
        }
    },
}
</script>
